import get from "lodash.get";
import React, { FC } from "react";
import { useTranslation } from "react-i18next";
import { NotificationCardStyled } from "./NotificationCard.style";
import { INotificationCard } from "./NotificationCard.types";

const NotificationCard: FC<INotificationCard> = ({ notification }) => {
  const { t } = useTranslation();

  if (
    notification?.type !== "attendanceCheck" &&
    notification?.type !== "taskDeadline"
  )
    return null;

  return (
    <NotificationCardStyled hasSeen={notification.hasSeen}>
      {get(notification, "type", "") === "taskDeadline" ? (
        <div className="d-flex align-items-center  justify-content-between  mb-1">
          <div className="notification-card-title">
            {get(notification, "moderator.firstName", "") +
              " " +
              get(notification, "moderator.lastName", "")}
          </div>
          <div className="card-message">
            <code className="error">
              <p>
                {get(notification, "student.firstName", "") +
                  " " +
                  get(notification, "student.lastName", "")}{" "}
              </p>
              <p>{get(notification, "group.name", "")} </p>
              <p>{get(notification, "order.name", "")} </p>

              {t("GENERAL.ASSIGNMENT")}
            </code>
          </div>
        </div>
      ) : (
        <>
          <div className="d-flex align-items-center  justify-content-between  mb-1">
            <div className="notification-card-title">
              {get(notification, "group.name", "")}
            </div>
            <time>
              {get(notification, "group.courseShift.startHour", "") +
                "-" +
                get(notification, "group.courseShift.endHour", "")}
            </time>
          </div>
          <div className="card-message">
            {t("NOTIFICATIONS.ATTANDENCE_MESSAGE")}
          </div>
        </>
      )}
    </NotificationCardStyled>
  );
};

export default NotificationCard;
